/* eslint-disable jsx-a11y/anchor-is-valid */
import { faRedo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import { useStyles } from './ErrorTryAgain.styles'

type ErrorTryAgainProps = {
  onTryAgain: () => void
  marginTop?: boolean
  center?: boolean
}

export const ErrorTryAgain = ({
  onTryAgain,
  marginTop,
  center,
}: ErrorTryAgainProps) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <div className={cx(classes.container, marginTop && classes.marginTop)}>
      <p className={cx(classes.error, center && classes.centerText)}>
        {t('An error occurred. Please try again later or contact the support.')}
      </p>
      <div className={cx(center && classes.centerButton)}>
        <Button
          label={t('Try again')}
          size="sm"
          icon={<FontAwesomeIcon icon={faRedo} />}
          onClick={() => onTryAgain()}
        />
      </div>
    </div>
  )
}
